export { default as Exception } from "./Exception";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/exceptions/index.js
// module id = 47
// module chunks = 1